import axiosClient from '../axios/client';

const ORDER_EXTRACTION_BASE_URL = '/order-extractions';

export const orderExtractionApi = {
  // 1. Create a new order extraction
  async createOrderExtraction(customerId, files) {
    const request = {
      customerId: customerId || null,
      files: files.map(file => ({
        fileName: file.name,
        fileContentType: file.type
      }))
    };

    const response = await axiosClient.post(ORDER_EXTRACTION_BASE_URL, request);
    return response.data;
  },

  // 2. Upload file to presigned URL
  async uploadFileToPresignedUrl(presignedUrl, file) {
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      body: file
    });

    if (!response.ok) {
      throw new Error(`Failed to upload file: ${response.statusText}`);
    }

    return response;
  },

  // 3. Start the extraction process
  async startOrderExtractionProcess(orderExtractionId, additionalContext = null) {
    const request = {
      additionalContext: additionalContext
    };

    const response = await axiosClient.post(
      `${ORDER_EXTRACTION_BASE_URL}/${orderExtractionId}/start`,
      request
    );
    return response.data;
  },

  // 4. Get order extraction by ID
  async getOrderExtractionById(orderExtractionId) {
    const response = await axiosClient.get(`${ORDER_EXTRACTION_BASE_URL}/${orderExtractionId}`);
    return response.data;
  },

  // 5. List order extractions with pagination
  async listOrderExtractions(limit = 50, offset = 0) {
    const response = await axiosClient.get(ORDER_EXTRACTION_BASE_URL, {
      params: { limit, offset }
    });
    return response.data;
  },

  // 6. Update item quantity
  async updateItemQuantity(orderExtractionId, itemId, quantity) {
    const request = { quantity };
    const response = await axiosClient.put(
      `${ORDER_EXTRACTION_BASE_URL}/${orderExtractionId}/items/${itemId}/quantity`,
      request
    );
    return response.data;
  },

  // 7. Set item ignored status
  async setItemIgnored(orderExtractionId, itemId, ignored) {
    const request = { ignored };
    const response = await axiosClient.put(
      `${ORDER_EXTRACTION_BASE_URL}/${orderExtractionId}/items/${itemId}/ignored`,
      request
    );
    return response.data;
  },

  // 8. Select product code for item
  async selectProductCode(orderExtractionId, itemId, productCode) {
    const request = { productCode };
    const response = await axiosClient.put(
      `${ORDER_EXTRACTION_BASE_URL}/${orderExtractionId}/items/${itemId}/select-product-code`,
      request
    );
    return response.data;
  }
};

export default orderExtractionApi;
